// extracted by mini-css-extract-plugin
export default {"portal":"ModalPortal_portal__Co3nC","action":"ModalPortal_action__g-ZUS","btn":"ModalPortal_btn__odd93"};